<template>
  <div class="result">
    <div class="phone" v-show="!isPc">
        <h1><img src="../assets/success.png" alt=""></h1>
        <p>提交成功</p>
        <!-- <h1>{{code}}</h1> -->
        <p v-show="time!=''">环保部门将在{{time}}个工作日内完成认定。</p>
        <!-- <p>请保管好此查询码以便查询</p> -->
        <button @click="close" class="btn">关闭</button>
        <button @click="back" class="btn">返回</button>
    </div>
    <div class="pc" v-show="isPc">
        <!-- <h1>{{code}}</h1> -->
        <h1><img src="../assets/success.png" alt=""></h1>
        <p>提交成功</p>
        <p v-show="time!=''">环保部门将在{{time}}个工作日内完成认定。</p>
        <!-- <p>请保管好此查询码以便查询</p> -->
        <el-row>
            <!-- <el-col :span="4" :offset="9"><button @click="close" class="btn">关闭</button></el-col> -->
            <el-col :span="6" :offset="9"><button @click="back" class="btn">返回</button></el-col>
        </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'result',
  data(){
    return{
      isPc:false,
      // code:'123456',
      time:''
    }
  },
  methods:{
    close(){
      var ua = window.navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == 'micromessenger'){
        WeixinJSBridge.call('closeWindow');
      }else{
        window.opener = null;
        window.open("", "_self");
        window.close();
      }  
    },
    back(){
      window.history.go(-1)
    }
  },
  mounted(){
    this.isPc = window.innerWidth>640?true:false;
    // console.log(this.isPc)
    // let cxm = localStorage.getItem('cxm');
    let ywlx = localStorage.getItem('ywlx')
    // this.code = cxm;
    if(ywlx==2){
      this.time = '一'
    }
    if(ywlx==0){
      this.time ='半'
    }
  }
}
</script>
<style scoped>
.phone{
  position: relative;
  height: 76vh;
  padding: 20vh 5vw 4vh 5vw;
}
p{
    font-size: 3vh;
}
h1{
    font-size: 10vh;
    padding: 2vh;
    line-height: 24vh;
    color: rgb(0, 198, 49);
}
h1 img {
  height: 18vh;
}
.phone .btn{
    width: 90vw;
    position: absolute;
    bottom: 2vh;
    left: 5vw;
}
.pc{
  width: 50vw;
  padding: 5vh;
  margin: 15vh 22.5vw;
  background: #fff;
}
.pc .btn{
    margin-top: 4vh;
}
</style>